<div
	class="order-book"
	[class.open]="isOpen()"
>
	@if (isExpanded) {
		<div class="header">
			<span class="title">{{ 'orderBook.title' | translate }}</span>
			<tui-icon
				[icon]="isOpen() ? '@tui.minus' : '@tui.plus'"
				class="icon"
				(click)="toggleOpen()"
			/>
		</div>
	}

	<tui-expand [expanded]="isOpen()">
		@if (viewType === 'linear') {
			<app-order-book-linear
				[orderBook]="orderBook"
				[isLoading]="isLoading"
			/>
		} @else {
			<app-order-book-diagrammatic
				[orderBook]="orderBook"
				[isLoading]="isLoading"
			/>
		}
	</tui-expand>
</div>
